import script from "./ViewExamContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewExamContent.vue?vue&type=script&setup=true&lang=ts"

import "./ViewExamContent.vue?vue&type=style&index=0&id=6edbb5c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edbb5c0"]])

export default __exports__